import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaClock, FaChevronLeft, FaLinkedin, FaTwitter, FaFacebook } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog3 = () => {
    const blogPost = {
        id: 4,
        title: "Opérations de fusions-acquisitions : sécurisez votre croissance",
        excerpt: "Les opérations de fusion-acquisition (M&A) représentent des leviers de croissance parmi les plus puissants pour une entreprise. Elles permettent d'accélérer le développement, de conquérir de nouveaux marchés, d'acquérir des technologies ou de réaliser des synergies significatives.",
        content: `
      <p class="lead">Les opérations de fusion-acquisition (M&A) représentent des leviers de croissance parmi les plus puissants pour une entreprise. Elles permettent d'accélérer le développement, de conquérir de nouveaux marchés, d'acquérir des technologies ou de réaliser des synergies significatives. Cependant, leur complexité juridique et financière en fait des opérations à haut risque.</p>
      
      <p>Une exécution rigoureuse, encadrée par des professionnels experts, est la clé pour transformer un projet stratégique en une réussite durable. Cet article vous propose un guide complet pour démystifier les opérations de fusion, en accord avec le droit des affaires de l'OHADA.</p>
      
      <h3>1. Le Paysage Stratégique : Pourquoi et Comment se Restructurer ?</h3>
      
      <p>Avant d'entrer dans la technique, il est crucial de comprendre les motivations et les différentes formes que peut prendre une restructuration d'entreprise.</p>
      
      <h4>Les Motivations Stratégiques derrière une Fusion</h4>
      
      <p>Une fusion n'est jamais une fin en soi. Elle répond à des objectifs stratégiques clairs :</p>
      
      <ul>
        <li><strong>La Synergie :</strong> L'union des forces doit créer une valeur supérieure à la somme des parties (principe du "1+1=3"). Il peut s'agir de synergies de coûts (rationalisation des fonctions support), de revenus (vente croisée de produits) ou industrielles (optimisation de la production).</li>
        <li><strong>La Croissance Externe :</strong> Acquérir une entreprise est souvent plus rapide que de développer une nouvelle activité en interne. C'est un moyen efficace d'augmenter sa part de marché.</li>
        <li><strong>La Diversification :</strong> Entrer dans de nouveaux secteurs d'activité ou de nouvelles zones géographiques pour réduire sa dépendance à un seul marché.</li>
        <li><strong>L'Acquisition de Talents ou de Technologies :</strong> Intégrer des compétences clés, des brevets ou un savoir-faire technologique difficile à développer soi-même.</li>
      </ul>
      
      <h4>Les Différentes Formes de Rapprochement</h4>
      
      <p>Le droit OHADA, à travers l'Acte Uniforme relatif au Droit des Sociétés Commerciales et du Groupement d'Intérêt Économique (AUSCGIE), encadre plusieurs types d'opérations :</p>
      
      <h5>• La Fusion</h5>
      <p>L'opération par laquelle deux (2) ou plusieurs sociétés se réunissent pour n'en former qu'une seule. C'est l'équivalent de deux rivières qui se rejoignent pour n'en former qu'une plus grande. Elle peut se faire par création d'une société nouvelle ou par absorption par l'une d'entre elles.</p>
      <p>La conséquence majeure est la transmission à titre universel du patrimoine : la société absorbée disparaît et l'ensemble de ses actifs et passifs est transféré à la société absorbante (article 189 de l'AUSCGIE).</p>
      
      <h5>• La Scission</h5>
      <p>L'opération inverse de la fusion. Le patrimoine d'une société est partagé et transmis à plusieurs sociétés existantes ou nouvelles. La société d'origine disparaît après avoir "éclaté" en plusieurs entités distinctes (article 190 de l'AUSCGIE).</p>
      
      <h5>• L'Apport Partiel d'Actif</h5>
      <p>Une opération hybride où une société apporte une branche autonome d'activité (par exemple, sa division "logistique") à une autre société, en échange de titres de cette dernière. Contrairement à la fusion, la société apporteuse ne disparaît pas. Elle devient simplement actionnaire de la société bénéficiaire de l'apport. Cette opération est soumise au régime juridique de la scission (article 195 de l'AUSCGIE).</p>
      
      <h3>2. Le Cadre de l'Opération : Principes et Étapes Clés</h3>
      
      <p>Une fois la stratégie définie, l'opération doit suivre un cadre juridique et comptable strict pour garantir sa validité et sa transparence.</p>
      
      <h4>Les Principes Fondamentaux d'Évaluation</h4>
      
      <p>La comptabilisation d'une fusion n'est pas laissée au libre arbitre. Elle repose sur des principes directeurs :</p>
      
      <ol>
        <li><strong>Référence au Traité d'Apport :</strong> Ce document contractuel est la pierre angulaire de l'opération. Il fixe les conditions juridiques, économiques et financières de la fusion.</li>
        <li><strong>Une Méthode d'Évaluation Unique :</strong> Pour une situation donnée, une seule méthode d'évaluation doit être appliquée pour garantir la cohérence et la comparabilité des chiffres.</li>
        <li><strong>Détermination du Contrôle :</strong> La méthodologie s'inspire de celle des comptes consolidés pour déterminer si les entités sont sous contrôle exclusif (une entité détient le pouvoir sur l'autre) ou contrôle conjoint. Ce diagnostic déterminera la méthode comptable à appliquer.</li>
        <li><strong>Neutralité de l'Opération :</strong> Pour les fusions entre entités sous contrôle exclusif, l'opération doit être neutre. C'est-à-dire qu'elle ne doit pas générer artificiellement un profit ou une perte dans les comptes de l'absorbante, ni impacter ses capitaux propres au-delà de la simple addition des valeurs existantes.</li>
      </ol>
      
      <h4>Les Étapes Incontournables du Processus de Fusion</h4>
      
      <p>L'article 674 de l'AUSCGIE impose un formalisme rigoureux pour protéger les actionnaires. Voici le déroulé type :</p>
      
      <h5>a) Rédaction du Projet de Fusion</h5>
      <p>Le conseil d'administration des sociétés concernées élabore un projet commun détaillant les motifs, les buts, les conditions de l'opération et notamment la parité d'échange (le rapport d'échange entre les actions).</p>
      
      <h5>b) Intervention des Commissaires</h5>
      <p>Le commissaire à la fusion est désigné pour vérifier l'équité de la parité d'échange. Parallèlement, le commissaire aux apports de la société absorbante évalue la valeur des apports de la société absorbée.</p>
      
      <h5>c) Mise à Disposition des Documents</h5>
      <p>Au moins 15 jours avant le vote, les actionnaires doivent avoir accès à un dossier complet incluant :</p>
      <ul>
        <li>Le projet de fusion.</li>
        <li>Les rapports du conseil d'administration, du commissaire à la fusion et du commissaire aux apports.</li>
        <li>Les états financiers et rapports de gestion des trois derniers exercices de toutes les sociétés participantes.</li>
        <li>Un état comptable récent si les derniers comptes annuels datent de plus de six mois.</li>
      </ul>
      
      <h5>d) Vote en Assemblée Générale Extraordinaire (AGE)</h5>
      <p>Chaque société doit faire approuver le projet par ses actionnaires. L'AGE de l'absorbante statue également sur l'approbation des apports en nature. <strong>Le non-respect de ces formalités peut entraîner l'annulation de l'opération.</strong></p>
      
      <h3>3. Les Gardiens du Processus : Rôles Clés des Professionnels du Chiffre</h3>
      
      <p>Le succès d'une fusion repose sur l'intervention coordonnée de plusieurs professionnels du chiffre aux missions distinctes mais complémentaires. Leur expertise est une condition sine qua non de la sécurisation de l'opération.</p>
      
      <h4>L'Expert-Comptable : L'Architecte de l'Opération</h4>
      
      <p>Agissant pour le compte de l'absorbante ou de l'absorbée, l'expert-comptable est le conseiller stratégique et financier du dirigeant.</p>
      
      <ul>
        <li><strong>Audit d'Acquisition (Due Diligence) :</strong> Il dissèque les comptes et l'organisation de la cible pour identifier les risques (fiscaux, sociaux, cachés) et les opportunités.</li>
        <li><strong>Évaluation d'Entreprise :</strong> Il met en œuvre les méthodes financières pour valoriser la cible et objectiver la négociation du prix et de la parité d'échange.</li>
        <li><strong>Ingénierie Juridique et Fiscale :</strong> Il conseille sur le montage le plus optimisé pour structurer la transaction.</li>
        <li><strong>Assistance à la Négociation :</strong> Il arme le dirigeant avec des arguments chiffrés pour défendre les intérêts de son client.</li>
      </ul>
      
      <p><em>Son rôle : Partisan et stratégique. Il défend les intérêts d'une seule partie.</em></p>
      
      <h4>Le Commissaire aux Comptes : Le Garant de la Transparence</h4>
      
      <p>La mission du Commissaire aux Comptes (CAC) est légale et antérieure à l'opération de fusion.</p>
      
      <ul>
        <li><strong>Fiabilisation de l'Information :</strong> En certifiant dans le passé que les comptes des sociétés sont réguliers, sincères et donnent une image fidèle, il fournit une base d'information crédible et fiable sur laquelle toutes les parties (y compris les autres experts) vont s'appuyer.</li>
        <li><strong>Socle de la Confiance :</strong> Son rapport de certification est le point de départ de la due diligence. Son travail est le fondement de la confiance financière entre les parties.</li>
      </ul>
      
      <p><em>Son rôle : Historique et fondamental. Il atteste de la fiabilité de l'information financière passée.</em></p>
      
      <h4>Le Commissaire aux Apports : Le Protecteur du Capital</h4>
      
      <p>Désigné par la justice, le Commissaire aux Apports (CAA) a une mission légale cruciale et très ciblée. Il intervient pour le compte de la société absorbante.</p>
      
      <ul>
        <li><strong>Évaluation des Apports en Nature :</strong> Sa mission principale est d'apprécier, sous sa responsabilité, la valeur des biens apportés par la société absorbée à la société absorbante. Il vérifie que la valeur de ces apports n'est pas surévaluée.</li>
        <li><strong>Protection des Actionnaires (Anciens et Nouveaux) :</strong> En validant la valeur de l'apport, il protège les actionnaires existants de la société absorbante contre une dilution de leurs titres qui serait causée par une surévaluation des biens reçus. Il protège également les actionnaires de l'absorbée en assurant que leur contribution est reconnue à sa juste valeur.</li>
        <li><strong>Garantie de l'Intégrité du Capital Social :</strong> Il s'assure que le capital social de la société absorbante, qui sera augmenté suite à la fusion, repose sur une valeur réelle et non sur des actifs surévalués.</li>
      </ul>
      
      <p><em>Son rôle : Technique et légal. Il garantit la valeur objective des actifs transmis pour protéger l'intégrité du capital de la société bénéficiaire.</em></p>
      
      <h4>Le Commissaire à la Fusion : L'Arbitre de l'Équité</h4>
      
      <p>Également désigné par la justice, ce professionnel est totalement indépendant des sociétés qui fusionnent. Sa mission est plus large que celle du CAA et vise à protéger tous les actionnaires.</p>
      
      <ul>
        <li><strong>Vérification des Valeurs Relatives :</strong> Il s'assure que les valeurs retenues pour les titres de toutes les sociétés participant à l'opération sont pertinentes.</li>
        <li><strong>Contrôle de l'Équité du Rapport d'Échange :</strong> C'est le cœur de sa mission. Il vérifie que la parité de fusion (combien d'actions de la nouvelle entité recevront les actionnaires de l'absorbée) est juste et ne lèse aucune partie. C'est le "taux de change" entre les actions des deux sociétés.</li>
        <li><strong>Rédaction d'un Rapport Motivé :</strong> Il présente ses conclusions dans un rapport mis à la disposition des actionnaires avant leur vote en AGE, leur permettant de prendre une décision éclairée sur l'équilibre global de l'opération.</li>
      </ul>
      
      <p><em>Son rôle : Indépendant et impartial. Il garantit l'équité globale de la transaction pour tous les actionnaires.</em></p>
      
      <blockquote>
        <strong>Conclusion : Une Synergie d'Expertises pour une Croissance Maîtrisée</strong><br><br>
        Loin d'être redondants ou interchangeables, l'expert-comptable, le commissaire aux comptes, le commissaire aux apports et le commissaire à la fusion forment un quatuor d'experts essentiel à la réussite et à la sécurité juridique et financière de toute opération de fusion.
      </blockquote>
      
      <p>Leur complémentarité peut se résumer ainsi :</p>
      <ul>
        <li>L'expert-comptable conseille et défend les intérêts d'une partie.</li>
        <li>Le commissaire aux comptes atteste de la fiabilité de l'information historique.</li>
        <li>Le commissaire aux apports protège le capital en certifiant la valeur des actifs transmis.</li>
        <li>Le commissaire à la fusion garantit l'équité globale de l'opération pour tous les actionnaires.</li>
      </ul>
      
      <p>L'intervention coordonnée de ces quatre professionnels, tous membres de l'Ordre des Experts-Comptables, est le meilleur gage pour transformer un projet stratégique complexe en une réussite financière, opérationnelle et humaine durable.</p>
      
      <h4>Pour Aller plus loin :</h4>
      <ul>
        <li><a href="https://www.ohada.org" target="_blank" rel="noopener noreferrer">Site officiel de l'OHADA : www.ohada.org</a></li>
        <li><a href="https://www.ohada.com" target="_blank" rel="noopener noreferrer">Jurisprudence et documentation : www.ohada.com</a></li>
        <li><a href="https://oeccabenin.bj/" target="_blank" rel="noopener noreferrer">Site de l'Ordre des Experts-comptables : https://oeccabenin.bj/</a></li>
      </ul>
    `,
        
        categories: ["Fusion", "Stratégie", "Droit des sociétés"],
        tags: ["Fusion", "Acquisition", "OHADA", "Expert-comptable", "Due diligence", "Évaluation", "AUSCGIE"],
        date: "24 Septembre 2025",
        author: "Wilfrid DEDJI",
        authorTitle: "Expert-Comptable spécialisé en fusions-acquisitions",
        readTime: "12 min",
        featured: true
    };

    const similarBlogs = [
        {
            id: 1,
            title: "Votre guide pour saisir les opportunités au Bénin : L'âge d'or des PME",
            image: "/assets/images/image1.png",
            date: "25 août 2025",
            category: "Développement"
        },
        {
            id: 2,
            title: "Digitalisation fiscale au Bénin : Maîtrisez la plateforme e-Services",
            image: "/assets/images/image8.png",
            date: "22 septembre 2025",
            category: "Fiscalité"
        }
    ];

    return (
        <>
            <Header />

            <div className="blog-content py-5">
                <div className="container">
                    <nav className="breadcrumb-container mb-4">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/" className="text-decoration-none">Accueil</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/actualites/blog" className="text-decoration-none">Blog</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {blogPost.title}
                            </li>
                        </ol>
                    </nav>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="blog-header mb-4">
                                <div className="categories-badges mb-3">
                                    {blogPost.categories.map((category, index) => (
                                        <span key={index} className="category-badge me-2">{category}</span>
                                    ))}
                                </div>
                                <h1 className="blog-title">{blogPost.title}</h1>

                                <div className="blog-meta d-flex align-items-center mt-3">
                                    <div className="meta-item d-flex align-items-center">
                                        <FaCalendarAlt className="meta-icon" />
                                        <span>{blogPost.date}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center">
                                        <FaUser className="meta-icon" />
                                        <span>{blogPost.author}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center">
                                        <FaClock className="meta-icon" />
                                        <span>{blogPost.readTime} de lecture</span>
                                    </div>
                                </div>
                            </div>

                            <div className="blog-excerpt mb-4">
                                <p className="lead">{blogPost.excerpt}</p>
                            </div>

                            <div className="blog-body mb-5" dangerouslySetInnerHTML={{ __html: blogPost.content }} />

                            <div className="blog-tags mb-4">
                                {blogPost.tags.map((tag, index) => (
                                    <Link key={index} to={``} className="blog-tag">
                                        #{tag}
                                    </Link>
                                ))}
                            </div>

                            <div className="blog-share mb-5">
                                <h5 className="share-title">Partager cet article</h5>
                                <div className="social-buttons">
                                    <a href="#" className="social-button linkedin">
                                        <FaLinkedin />
                                    </a>
                                    <a href="#" className="social-button twitter">
                                        <FaTwitter />
                                    </a>
                                    <a href="#" className="social-button facebook">
                                        <FaFacebook />
                                    </a>
                                </div>
                            </div>

                            <div className="blog-actions mb-5">
                                <Link to="/actualites/blog" className="btn btn-back">
                                    <FaChevronLeft className="me-2" /> Retour au blog
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="sidebar-widget author-widget">
                                <h4 className="widget-title">À propos de l'auteur</h4>
                                <div className="author-profile">
                                    <div className="author-image">
                                        <img src="../assets/images/image5.png" alt={blogPost.author} className="img-fluid rounded-circle" />
                                    </div>
                                    <div className="author-info">
                                        <h5 className="author-name">{blogPost.author}</h5>
                                        <p className="author-title">{blogPost.authorTitle}</p>
                                        <p className="author-bio">Expert-comptable spécialisé dans l'accompagnement des entreprises dans leurs opérations de croissance externe et de restructuration. Fort de nombreuses années d'expérience dans le conseil en fusions-acquisitions selon le droit OHADA.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="sidebar-widget similar-blogs-widget">
                                <h4 className="widget-title">Articles similaires</h4>
                                <div className="similar-blogs">
                                    {similarBlogs.map((similarBlog) => (
                                        <Link key={similarBlog.id} to={`/blog/${similarBlog.id}`} className="similar-blog">
                                            <div className="similar-blog-image">
                                                <img src={similarBlog.image} alt={similarBlog.title} className="img-fluid rounded" />
                                                <span className="category-badge small">{similarBlog.category}</span>
                                            </div>
                                            <div className="similar-blog-content">
                                                <h5 className="similar-blog-title">{similarBlog.title}</h5>
                                                <div className="similar-blog-date">
                                                    <FaCalendarAlt className="me-1" size={12} />
                                                    <small>{similarBlog.date}</small>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className="sidebar-widget newsletter-widget">
                                <h4 className="widget-title">Newsletter</h4>
                                <p className="newsletter-desc">Recevez nos conseils sur les opérations de croissance externe et les dernières actualités juridiques et fiscales OHADA</p>
                                <form className="newsletter-form">
                                    <div className="form-group mb-3">
                                        <input type="email" className="form-control" placeholder="Votre adresse email" required />
                                    </div>
                                    <button type="submit" className="btn btn-primary w-100">S'abonner</button>
                                </form>
                            </div>

                            <div className="sidebar-widget categories-widget">
                                <h4 className="widget-title">Ressources OHADA</h4>
                                <ul className="categories-list">
                                    <li><a href="https://www.ohada.org" target="_blank" rel="noopener noreferrer">Site officiel OHADA <span>→</span></a></li>
                                    <li><a href="https://www.ohada.com" target="_blank" rel="noopener noreferrer">Jurisprudence OHADA <span>→</span></a></li>
                                    <li><a href="https://oeccabenin.bj/" target="_blank" rel="noopener noreferrer">Ordre des Experts-Comptables <span>→</span></a></li>
                                    <li><Link to="/services/fusion-acquisition">Nos services M&A <span>→</span></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Merriweather:wght@300;400;700&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .blog-content {
          background: linear-gradient(to bottom, #fafbfc 0%, #ffffff 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          color: #1a1a1a;
        }

        .breadcrumb {
          background: transparent;
          padding: 0;
          margin: 0;
          font-size: 0.9rem;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          content: "›";
          color: #94a3b8;
          font-size: 1.1rem;
        }

        .breadcrumb-item a {
          color: #64748b;
          text-decoration: none;
          transition: color 0.2s;
          font-weight: 500;
        }

        .breadcrumb-item a:hover {
          color: #dc2626;
        }

        .breadcrumb-item.active {
          color: #334155;
          font-weight: 500;
        }

        .blog-header {
          margin-bottom: 2.5rem;
        }

        .categories-badges {
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .category-badge {
          font-family: 'Inter', sans-serif;
          font-size: 0.8125rem;
          font-weight: 600;
          letter-spacing: 0.025em;
          padding: 0.375rem 0.875rem;
          border-radius: 6px;
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          text-transform: uppercase;
          display: inline-block;
        }

        .blog-title {
          font-family: 'Merriweather', Georgia, serif;
          font-size: 2.75rem;
          font-weight: 700;
          line-height: 1.2;
          color: #0f172a;
          margin-top: 1rem;
          margin-bottom: 0;
          letter-spacing: -0.02em;
        }

        .blog-meta {
          display: flex;
          gap: 1.5rem;
          flex-wrap: wrap;
          padding-top: 1rem;
          border-top: 1px solid #e2e8f0;
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9375rem;
          color: #64748b;
          font-weight: 500;
        }

        .meta-icon {
          color: #dc2626;
          font-size: 1rem;
        }

        .blog-excerpt {
          background: white;
          border-left: 4px solid #16a34a;
          padding: 1.75rem;
          border-radius: 0 8px 8px 0;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }

        .blog-excerpt .lead {
          font-family: 'Inter', sans-serif;
          font-size: 1.125rem;
          line-height: 1.75;
          color: #334155;
          font-weight: 400;
          margin: 0;
        }

        .blog-body {
          font-family: 'Inter', sans-serif;
          font-size: 1.0625rem;
          line-height: 1.8;
          color: #1e293b;
          background: white;
          padding: 2.5rem;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }

        .blog-body h3 {
          font-family: 'Merriweather', Georgia, serif;
          font-size: 1.875rem;
          font-weight: 700;
          color: #0f172a;
          margin-top: 3rem;
          margin-bottom: 1.25rem;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid #dc2626;
          display: inline-block;
          letter-spacing: -0.01em;
        }

        .blog-body h4 {
          font-family: 'Inter', sans-serif;
          font-size: 1.375rem;
          font-weight: 700;
          color: #1e293b;
          margin-top: 2.25rem;
          margin-bottom: 1rem;
          letter-spacing: -0.01em;
        }

        .blog-body h5 {
          font-family: 'Inter', sans-serif;
          font-size: 1.125rem;
          font-weight: 600;
          color: #334155;
          margin-top: 1.75rem;
          margin-bottom: 0.75rem;
          letter-spacing: -0.01em;
        }
        .blog-body p {
          margin-bottom: 1.75rem;
          margin-bottom: 0.875rem;
          letter-spacing: -0.005em;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
          text-align: justify;
          color: #334155;
          hyphens: auto;
        }

        .blog-body ul, .blog-body ol {
          margin-bottom: 1.75rem;
          padding-left: 1.5rem;
        }

        .blog-body li {
          margin-bottom: 0.875rem;
          line-height: 1.75;
          color: #475569;
        }

        .blog-body li strong {
          color: #16a34a;
          font-weight: 600;
        }

        .blog-body blockquote {
          position: relative;
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border: none;
          border-left: 5px solid #dc2626;
          padding: 2rem 2rem 2rem 2.5rem;
          margin: 2.5rem 0;
          border-radius: 0 12px 12px 0;
          font-style: normal;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);
        }

        .blog-body blockquote strong {
          display: block;
          font-size: 1.25rem;
          color: #0f172a;
          margin-bottom: 0.75rem;
          font-weight: 700;
        }

        .blog-body a {
          color: #dc2626;
          text-decoration: none;
          font-weight: 500;
          border-bottom: 1px solid transparent;
          transition: all 0.2s;
        }

        .blog-body a:hover {
          border-bottom-color: #dc2626;
        }

        .blog-body em {
          color: #64748b;
          font-style: italic;
          font-size: 0.9375rem;
        }

        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.625rem;
          padding: 1.5rem 0;
          border-top: 2px solid #f1f5f9;
          border-bottom: 2px solid #f1f5f9;
        }

        .blog-tag {
          font-family: 'Inter', sans-serif;
          font-size: 0.875rem;
          font-weight: 500;
          padding: 0.5rem 1rem;
          background: white;
          color: #64748b;
          border: 1.5px solid #e2e8f0;
          border-radius: 20px;
          text-decoration: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .blog-tag:hover {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          border-color: transparent;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
        }

        .blog-share {
          padding: 1.5rem 0;
          border-bottom: 2px solid #f1f5f9;
        }

        .share-title {
          font-family: 'Inter', sans-serif;
          font-size: 1rem;
          font-weight: 600;
          color: #334155;
          margin-bottom: 1rem;
          letter-spacing: -0.01em;
        }

        .social-buttons {
          display: flex;
          gap: 0.75rem;
        }

        .social-button {
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          color: white;
          text-decoration: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-size: 1.25rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .social-button.linkedin {
          background: #0077b5;
        }

        .social-button.twitter {
          background: #1da1f2;
        }

        .social-button.facebook {
          background: #4267b2;
        }

        .social-button:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 16px rgba(0,0,0,0.15);
        }

        .btn-back {
          font-family: 'Inter', sans-serif;
          display: inline-flex;
          align-items: center;
          padding: 0.875rem 1.75rem;
          background: #334155;
          color: white;
          border: none;
          border-radius: 10px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.9375rem;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 2px 8px rgba(51, 65, 85, 0.2);
        }

        .btn-back:hover {
          background: #1e293b;
          color: white;
          transform: translateX(-4px);
          box-shadow: 0 4px 12px rgba(51, 65, 85, 0.3);
        }

        .sidebar-widget {
          background: white;
          border-radius: 12px;
          padding: 2rem;
          margin-bottom: 1.75rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          border: 1px solid #f1f5f9;
        }

        .widget-title {
          font-family: 'Inter', sans-serif;
          font-size: 1.125rem;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 1.5rem;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid transparent;
          border-image: linear-gradient(to right, #dc2626, #16a34a) 1;
          letter-spacing: -0.01em;
        }

        .author-profile {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .author-image {
          margin-bottom: 1.25rem;
        }

        .author-image img {
          width: 90px;
          height: 90px;
          object-fit: cover;
          border: 3px solid #dc2626;
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
        }

        .author-name {
          font-family: 'Inter', sans-serif;
          font-size: 1.125rem;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 0.375rem;
          letter-spacing: -0.01em;
        }

        .author-title {
          font-size: 0.875rem;
          color: #16a34a;
          font-weight: 600;
          margin-bottom: 1rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .author-bio {
          font-size: 0.9375rem;
          line-height: 1.6;
          color: #64748b;
          margin: 0;
        }

        .similar-blogs {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }

        .similar-blog {
          display: flex;
          gap: 1rem;
          padding: 1rem;
          border-radius: 10px;
          text-decoration: none;
          color: inherit;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1.5px solid #f1f5f9;
        }

        .similar-blog:hover {
          background: #fafbfc;
          border-color: #dc2626;
          transform: translateY(-3px);
          box-shadow: 0 6px 16px rgba(220, 38, 38, 0.1);
        }

        .similar-blog-image {
          flex-shrink: 0;
          position: relative;
        }

        .similar-blog-image img {
          width: 85px;
          height: 85px;
          object-fit: cover;
          border-radius: 8px;
        }

        .similar-blog-image .category-badge {
          position: absolute;
          top: -6px;
          right: -6px;
          font-size: 0.625rem;
          padding: 0.25rem 0.5rem;
        }

        .similar-blog-content {
          flex: 1;
        }

        .similar-blog-title {
          font-family: 'Inter', sans-serif;
          font-size: 0.9375rem;
          font-weight: 600;
          line-height: 1.4;
          margin-bottom: 0.5rem;
          color: #1e293b;
          letter-spacing: -0.01em;
        }

        .similar-blog-date {
          font-size: 0.8125rem;
          color: #94a3b8;
          display: flex;
          align-items: center;
          font-weight: 500;
        }

        .newsletter-widget {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
        }

        .newsletter-widget .widget-title {
          color: white;
          border-image: linear-gradient(to right, rgba(255,255,255,0.5), rgba(255,255,255,0.5)) 1;
        }

        .newsletter-desc {
          font-size: 0.9375rem;
          line-height: 1.6;
          margin-bottom: 1.5rem;
          opacity: 0.95;
        }

        .newsletter-form .form-control {
          border: none;
          border-radius: 10px;
          padding: 0.875rem 1rem;
          font-size: 0.9375rem;
          font-family: 'Inter', sans-serif;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .newsletter-form .form-control:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(255,255,255,0.3);
        }

        .newsletter-form .btn-primary {
          background: white;
          color: #dc2626;
          border: none;
          font-weight: 700;
          padding: 0.875rem;
          border-radius: 10px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-family: 'Inter', sans-serif;
          font-size: 0.9375rem;
          letter-spacing: 0.025em;
          text-transform: uppercase;
        }

        .newsletter-form .btn-primary:hover {
          background: #f8fafc;
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.2);
        }

        .categories-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .categories-list li {
          margin-bottom: 0.75rem;
        }

        .categories-list li:last-child {
          margin-bottom: 0;
        }

        .categories-list a {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.875rem 1rem;
          background: #fafbfc;
          border-radius: 10px;
          text-decoration: none;
          color: #475569;
          font-weight: 600;
          font-size: 0.9375rem;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1.5px solid #f1f5f9;
        }

        .categories-list a:hover {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          border-color: transparent;
          transform: translateX(5px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
        }

        .categories-list a span {
          font-size: 1rem;
          opacity: 0.7;
          transition: transform 0.3s;
        }

        .categories-list a:hover span {
          transform: translateX(3px);
        }

        @media (max-width: 991.98px) {
          .blog-title {
            font-size: 2rem;
          }

          .blog-meta {
            flex-direction: column;
            gap: 0.75rem;
          }

          .blog-body {
            padding: 1.75rem;
          }

          .similar-blog {
            flex-direction: column;
            text-align: center;
          }

          .similar-blog-image {
            align-self: center;
          }
        }

        @media (max-width: 767.98px) {
          .blog-title {
            font-size: 1.75rem;
          }

          .blog-body {
            font-size: 1rem;
            padding: 1.5rem;
          }

          .blog-body h3 {
            font-size: 1.5rem;
          }

          .blog-body h4 {
            font-size: 1.25rem;
          }

          .sidebar-widget {
            padding: 1.5rem;
          }

          .author-profile {
            flex-direction: row;
            text-align: left;
            gap: 1rem;
          }

          .author-image {
            margin-bottom: 0;
          }

          .author-image img {
            width: 70px;
            height: 70px;
          }
        }
      `}
            </style>
        </>
    );
};

export default DetailBlog3;